"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HomeOutlinedIcon = HomeOutlinedIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function HomeOutlinedIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.6 1.95C9.24444 1.68333 8.75556 1.68333 8.4 1.95L3.4 5.7C3.14819 5.88885 3 6.18524 3 6.5V14C3 14.5523 3.44772 15 4 15H5.75C6.30228 15 6.75 14.5523 6.75 14V10.75C6.75 10.1977 7.19772 9.75 7.75 9.75H10.25C10.8023 9.75 11.25 10.1977 11.25 10.75V14C11.25 14.5523 11.6977 15 12.25 15H14C14.5523 15 15 14.5523 15 14V6.5C15 6.18524 14.8518 5.88885 14.6 5.7L9.6 1.95Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }));
}